// extracted by mini-css-extract-plugin
export default {"tableHead":"CardHead_tableHead__hjOVo","tableHeadRow":"CardHead_tableHeadRow__uS5Tw"};